import React from 'react';
import styled from 'styled-components';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import {
  SWOTIconSAP,
  SmartAccountTitleText,
  accountOverviewSAP,
  businessCaseSAP,
  businessRiskSAP,
  businessSegmentSAP,
  buyerAnalysisSAP,
  buyerGroupSAP,
  challengesPainpointsSAP,
  competitorAnalysisSAP,
  financialSummarySAP,
  growthOppertunitiesSAP,
  maxMobile,
  maxWidth, primaryFont, primaryHeadingColor, retina, riskMitigationsSAP, solutionIconSAP, wMedium,
} from 'Utils/utilsStyle';

import { Checkbox } from 'antd';
import { SAPSection } from 'Types/CompaniesTypes';
import { useDispatch } from 'react-redux';
import { actions } from 'Slice/CompaniesSlice';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  .smart-heading-title-tooltip {
    display: flex;
    width: calc(100% - 15px);
    ${SmartAccountTitleText};
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 16px;
      line-height: 18px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      line-height: 16px;
    }
    margin-bottom: 12px;
    .global-tooltip-element {
      position: relative;
      display: inline-flex;
      .section-detail-tip {
        .ant-tooltip {
          left: unset !important;
          right: 25px !important;
          top: 10px !important;
        }
      }
    }
  }
  .document-section-tile {
    display: flex;
    align-items: center;
    margin-bottom: 11px;
    .ant-checkbox-wrapper {
      margin-bottom: 0px;
      width: 20px;
      height: 25px;
      .ant-checkbox {
        .ant-checkbox-inner {
          width: 20px;
          height: 20px;
        }
      }
    }
    .img-icon {
      width: 30px;
      height: 30px;
      margin: 0 6px;
    }
    .document-section-name {
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 15px;
      letter-spacing: -0.696px;
      margin-bottom: 0px;
    }
  }
`;

type Props = {
  sections: SAPSection[]
  summary: string,
  tooltipText: string,
  exampleText: string,
};

const getImageSource = (type: string) => {
  switch (type) {
    case 'account_overview':
      return accountOverviewSAP;
    case 'financial_summary':
      return financialSummarySAP;
    case 'business_segments':
      return businessSegmentSAP;
    case 'business_risks':
      return businessRiskSAP;
    case 'competitor_analysis':
      return competitorAnalysisSAP;
    case 'swot_analysis':
      return SWOTIconSAP;
    case 'growth_strategy':
      return growthOppertunitiesSAP;
    case 'challenges_and_pain_points':
      return challengesPainpointsSAP;
    case 'buyer_group':
      return buyerGroupSAP;
    case 'solution_alignment':
      return solutionIconSAP;
    case 'business_case':
      return businessCaseSAP;
    case 'buyer_analysis':
      return buyerAnalysisSAP;
    case 'risks_and_mitigations':
      return riskMitigationsSAP;
    default:
      return riskMitigationsSAP;
  }
};

const SmartDocumentSection = function SmartDocumentSection(props: Props) {
  const {
    sections, summary, tooltipText, exampleText,
  } = props;
  const dispatch = useDispatch();

  const handleChange = (checked: boolean, type: string) => {
    dispatch(actions.updateSAPDocSection({ type, value: checked }));
  };

  return (
    <Wrapper>
      <h1 className="smart-heading-title-tooltip">
        {summary}
        <HeadingWithToolTip
          heightIcon="19px"
          widthIcon="16px"
          heightIconSm="20px"
          widthIconSm="13px"
          customWidth="280px"
          toolTipText={tooltipText}
          exampleText={exampleText}
          toolPlacement="bottomRight"
          midTabletFlag
          htmlFlag
        />
      </h1>
      {sections.map((section) => (
        <div className="document-section-tile">
          <Checkbox
            checked={section.selected}
            onClick={() => handleChange(!section.selected, section.type)}
            tabIndex={-1}
          />
          <img src={getImageSource(section.type)} className="img-icon" alt="abc" />
          <span className="document-section-name">{section.title}</span>
        </div>
      ))}
    </Wrapper>
  );
};
export default SmartDocumentSection;
